import React from 'react';
import './InstructionsPopup.css';

export default function CaptureManual({ configValue, tryAutomatic, goManual }) {
  // Usar los mismos colores del configValue que se usan en el fondo y mensajes de status
  const backgroundColor = configValue?.styles?.backgroundColor || '#1a1a1a';
  const messageColor = configValue?.styles?.messageColor || '#ffffff';
  const messageBackgroundColor = configValue?.styles?.messageBackgroundColor || '#333333';
  const guideColor = configValue?.styles?.guideColor || '#00bcd4';

  return (
    <div className="instructions-popup-overlay" style={{ backgroundColor: backgroundColor }}>
      <div className="instructions-popup" style={{ backgroundColor: messageBackgroundColor }}>
        <div className="instructions-header">
          <h2 style={{ color: messageColor }}>No pudimos capturar tu documento</h2>
        </div>

        <div className="instructions-content">
            <p style={{ color: messageColor }}>
               Puedes intentar nuevamente de forma automatica o hacerlo de forma manual.
            </p>
        </div>

        <div className="instructions-footer" style={{display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center'}}>
          <button
            className="instructions-close-button"
            style={{
              backgroundColor: backgroundColor,
              color: messageColor,
              border: `2px solid ${messageColor}`
            }}
            onClick={tryAutomatic}
          >
            Reintentar
          </button>
            <button
            className="instructions-close-button"
            style={{
              backgroundColor: guideColor,
              color: messageBackgroundColor,
              border: `2px solid ${messageColor}`
            }}
            onClick={goManual}
          >
            Captura Manual
          </button>
        </div>
      </div>
    </div>
  );
}
